// const proApiBaseUrl = "https://material-test.huangfengdata.com";

// const devApiBaseUrl = "https://material-test.huangfengdata.com";

const proApiBaseUrl = "https://wechat-test.mrstage.com";

const devApiBaseUrl = "https://wechat-test.mrstage.com";
module.exports = {
    apiBaseUrl: process.env.NODE_ENV === "development" ? devApiBaseUrl : proApiBaseUrl
};